export default "__VITE_ASSET__D7yGts2l__"